require("!!/Users/jnunez/git/brandplay2/node_modules/script-loader/addScript.js")(require("!!/Users/jnunez/git/brandplay2/node_modules/raw-loader/index.js!/Users/jnunez/git/brandplay2/node_modules/amp-premier/amp.premier/amp.premier.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/amp-premier/amp.premier/amp.premier.js
// module id = 227
// module chunks = 0